export default "__VITE_ASSET__CvCpPqX5__"